module.exports = __webpack_public_path__ + "static/Oral rehabilitation smile after-6a0079f2c91d50e7cce2a5807bad3f2e.jpg";